import React, { useState } from 'react';
import { Button, Modal, Form, Input, Select, Spin, message } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { get, map } from 'lodash';
import { userMangement } from '../../redux/actions/authActions';
import { USER_ADDED_SUCCESS } from '../../constants/messages';

const { Option } = Select;

function AddNewUser(props) {
  const { refreshUserList } = props;
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const roles = useSelector((state) => get(state, 'config.roles'));
  const selectedCompany = useSelector((state) =>
    get(state, 'auth.selectedCompany')
  );
  const dispatch = useDispatch();

  const toggleUserModal = () => {
    setShowModal(!showModal);
  };

  const onFinish = (values) => {
    setLoading(true);
    dispatch(
      userMangement('create.user', {
        ...values,
        company_id: get(selectedCompany, 'id'),
        is_active: true,
      })
    )
      .then(() => {
        message.success(USER_ADDED_SUCCESS);
        toggleUserModal();
        refreshUserList();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Button className="default-btn" onClick={toggleUserModal}>
        + Add New User
      </Button>
      <Modal
        width="55%"
        className="common-modal"
        destroyOnClose
        closable={false}
        open={showModal}
        onOk={toggleUserModal}
        onCancel={toggleUserModal}
        footer={null}
        maskClosable={false}
      >
        <Spin spinning={loading}>
          <div className="heading">
            <LeftOutlined
              className="back-btn"
              onClick={() => {
                toggleUserModal();
              }}
            />
            Add New User
          </div>

          <div className="add-user-container">
            <Form
              name="basic"
              layout="vertical"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              autoComplete="off"
              requiredMark={false}
            >
              <div className="mt-20">
                <p className="subheading">
                  Enter the following details of the person to whom you want to
                  share the access
                </p>

                <p className="subheading">
                  <b>Remember : </b> A unique password will be generated and
                  share with the person to give them log in access
                </p>
              </div>
              <div className="mt-40 form-row">
                <div className="input-container">
                  <Form.Item
                    label="Enter Full Name"
                    name="name"
                    className="form-item"
                    rules={[
                      {
                        required: true,
                        message: 'Please input full name!',
                      },
                    ]}
                  >
                    <Input size="large" placeholder="Enter full name" />
                  </Form.Item>
                </div>

                <div className="input-container">
                  <Form.Item
                    label="Email id "
                    name="email"
                    className="form-item"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your registered email!',
                      },
                      {
                        type: 'email',
                        message: 'Please Input valid email',
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter Email or mobile no."
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="mt-20 form-row">
                <div className="input-container">
                  <Form.Item
                    label="Select User Type"
                    name="role_id"
                    className="form-item"
                    rules={[
                      {
                        required: true,
                        message: 'Please select user type!',
                      },
                    ]}
                  >
                    <Select placeholder="Select user type" size="large">
                      {map(roles, (role) => (
                        <Option key={get(role, 'id')} value={get(role, 'id')}>
                          {get(role, 'name')}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>

              <div className="btn-container mt-20">
                <div className="mt-20">
                  <Button block type="primary" htmlType="submit">
                    Continue
                  </Button>
                </div>
                <div className="mt-20 ">
                  <Button
                    className="default-btn"
                    onClick={toggleUserModal}
                    block
                  >
                    Go Back
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </Spin>
      </Modal>
    </>
  );
}

export default AddNewUser;
